<template>
  <div>
    <div class="row mt-2 mb-3 align-items-end" style="padding-left: 15px;">
      <div class="col pl-0">
        <div class="h4 mb-0 text-uppercase">Activity</div>
      </div>
      <div class="col">
        <div class="text-right text-uppercase" v-if="total > 5">
          <a href="#" class="font-weight-bold"  @click.prevent="openTasksLoggedFullListModal()">See All</a>
        </div>
      </div>
    </div>

        <div class="row mb-2 pl-3 pb-2 border-bottom ml-2" v-for="option in 5" v-if="notificationLoading == true">
          <div class="col-12 pl-2 pt-2">
            <div class="col-12">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-10">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
          </div>
        </div>

    
    <div class="row " style=" padding-left: 5px;">
      <div class="col">
        <div class="row mb-2 pl-3" v-for="(activityLog, index) in accountActivityLogs" :key="index">
          <div class="col">
            <div class="row pb-2 border-bottom">
              <div class="col-9 " style="padding-left: 0;">
                <div class="mb-0">{{ activityLog.title }}</div>
                <div class="small text-muted mb-0">{{ activityLog.description1 }}</div>
              </div>
              <div class="col-3 small text-right text-muted">{{ activityLog.createdAtFormatted }}</div>
            </div>
          </div>
        </div>
        
        <div class="row" v-if="accountActivityLogs.length == 0">
          <div class="col pl-1">
            <div>No logs.</div>
          </div>
        </div>

        <TasksLoggedFullList 
          :isModalVisible="isTasksLoggedFullListVisible"
          :menteeId="menteeId"
          @closeTasksLoggedFullListModal="closeTasksLoggedFullListModal"
          ref="TasksLoggedFullListModal">
        </TasksLoggedFullList>


      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TasksLoggedFullList from '@/components/manager/mentee_tasks_logged_full_list.vue';

export default {
  props: ['menteeId'],
  data: function () {
    return {
      accountActivityLogs: [],
      limit: 5,
      page: 1,
      total: 0,
      pageCount: 0,
      seeAllText: 'See All',
      showSeeAll: false,
      showSeeMore: false,
      isTasksLoggedFullListVisible: false,
      notificationLoading: false,
    }
  },
  components: {
    TasksLoggedFullList,
  },
  methods: {
    openTasksLoggedFullListModal() {
      this.$refs.TasksLoggedFullListModal.getActivityData();
      this.isTasksLoggedFullListVisible = true;
    },
    closeTasksLoggedFullListModal() {
      this.isTasksLoggedFullListVisible = false;
    },
    handleSeeAll() {
      if (this.seeAllText == 'See All') {
        this.page += 1;
        this.getAccountActivityLogs();
        this.seeAllText = 'See Less';
      } else {
        this.accountActivityLogs = [];
        this.page = 1;
        this.showSeeMore = false;
        this.getAccountActivityLogs();
        this.seeAllText = 'See All';
      }      
    },
    handleSeeMore() {
      this.page += 1;
      this.getAccountActivityLogs();
    },
    getAccountActivityLogs() {
      this.notificationLoading = true;
      axios.get('/desktop/v2/manager/mentee-task-logged', {
        params: {
          account_id: this.$store.state.user_accountid,
          mentee_id: this.menteeId,
          limit: this.limit,
          page: this.page,
        }
      })
      .then(response =>  {
        this.notificationLoading = false;
        let data = response.data;
        this.accountActivityLogs = this.accountActivityLogs.concat(data.account_activity_logs);
        this.total = data.total_count;
        this.pageCount = data.page_count;

        if (this.total > this.limit) {
          this.showSeeAll = true;
        }

        if (this.seeAllText == 'See Less' && this.page < this.pageCount) {
          this.showSeeMore = true;
        } else {
          this.showSeeMore = false;
        }
      })
      .catch(function() {});
    },
  },
  created() {
    this.getAccountActivityLogs();
  },
};
</script>

<style scoped>
a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}
</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_tasks_logged.vue